export default __webpack_public_path__ + "static/media/NVDA.f28fc211.png";